export default __webpack_public_path__ + "static/media/US_Hero5_2.e4ea361c.png";